package com.altmann.choresmanager.ui.screens.calendar.weeklycalendar

import androidx.compose.foundation.ScrollState
import androidx.compose.runtime.Composable

@Composable
actual fun ScrollBar(scrollState: ScrollState) {
}